import { LayoutBreakpoints } from '../../constants';

export interface InputGridOptions {
  columns?: number;

  /** If true, disables the column system and uses a simple wrapping flex layout */
  flex?: boolean;
}

function inputGridGetActiveStyles(layout: InputGridOptions, layoutLg: InputGridOptions) {
  let activeRules: InputGridOptions;

  if (window.innerWidth < LayoutBreakpoints.lg.min) {
    activeRules = layout;
  } else {
    activeRules = layoutLg;
  }

  return activeRules || {};
}

export function inputGridGetStyles(count: number, layout: InputGridOptions, layoutLg: InputGridOptions) {
  const styles = {} as any;
  let activeRules = inputGridGetActiveStyles(layout, layoutLg);

  if (activeRules.flex) {
    styles.display = 'flex';
    styles.flexWrap = 'wrap';
  } else {
    const columnCount = activeRules.columns || 1;
    const itemsPerColumn = Math.ceil(count / columnCount);

    styles.display = 'grid';
    styles.gridTemplateColumns = `repeat(${activeRules.columns || 1}, 1fr)`;
    styles.gridTemplateRows = `repeat(${itemsPerColumn}, 1fr)`;
  }

  return styles;
}

export function inputGridCheckFlex(layout: InputGridOptions, layoutLg: InputGridOptions) {
  let activeRules = inputGridGetActiveStyles(layout, layoutLg);
  return activeRules.flex;
}
